export default __webpack_public_path__ + "static/soc2-4a8889ca40bd0b9082f352983514f84c.png";